// extracted by mini-css-extract-plugin
export default {"mainSection":"VerificationPage_mainSection__Tluz+"};